"use client";

import { useMemo } from "react";

import { useConversationsFeature } from "@/features/conversations/hooks/use-conversations-feature";
import { FEATURE_FLAGS } from "@/lib/feature-flags";

import { JOB_TAB_ITEMS, type JobTabItem } from "./job-tab-items";

export function useVisibleJobTabItems(): JobTabItem[] {
  const enabled = useConversationsFeature();
  return useMemo(
    () =>
      JOB_TAB_ITEMS.filter(
        (item) =>
          (enabled || item.value !== "conversations") &&
          (FEATURE_FLAGS.scorecards || item.value !== "scorecards"),
      ),
    [enabled],
  );
}
